import BadgeStyle from "../templates/Badge.style";
import BadgeHzeroStyle from "../templates-hzero/Badge.style";
var badgeData = {
  name: 'badge',
  data: [{
    textFontSize: 12
  }],
  onlyTemplate: {
    base: BadgeStyle,
    hzero: BadgeHzeroStyle
  }
};
export default badgeData;